import dayjs from 'dayjs';

import { CrmResponseData, FormattedData, Offer } from '../types';

export function formatOfferSearchData(data: CrmResponseData): FormattedData {
  const mobileMoneyOperators = data.paymentMeans.find(
    ({ paymentMeanId }) => paymentMeanId === 'TS'
  );
  return {
    contractEndDate: dayjs(data.contract.endDate).format('DD/MM/YYYY'),
    offers: data.productEditorials.map(
      (offer): Offer => ({
        id: offer.id,
        title: offer.label,
        major: offer.type.major,
        minor: offer.type.minor,
        currency: offer.currency?.code ?? null,
        price: offer.totalCatalogPrice,
        detained: offer.detained,
        forbiddenOptions: offer.dependency.forbidden,
        categoryIndicator: offer.category.indicators
      })
    ),
    operators:
      mobileMoneyOperators?.ePaymentOperators?.map(operator => ({
        id: operator.ePaymentOperatorId
      })) ?? []
  };
}
